module.exports = __webpack_public_path__ + "static/media/closingGap_tablet.459895ff.png";